// extracted by mini-css-extract-plugin
module.exports = {"btns":"previewDrawer_btns__2AI-O"};